<template>
  <div id="container">
    <div class="home">
      <el-container>
        <el-container>
          <div class="side-bar-con">
          <div class="banner">XXX 管理系统</div>
            <el-aside width="200px">
              <div class="nav-con">
                <div class="nav-item" v-for="(app) in $apps" :key="app.name">
                  <a @click="goto(app)">{{app.name}}</a>
                </div>
              </div>
            </el-aside>
          </div>
          <el-container>
            <el-header>Header</el-header>
            <el-main>
              <div id="instance" />
            </el-main>
          </el-container>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
  import { loadMicroApp } from 'qiankun';

	export default {
    name: 'master',
		data () {
      return {
        currentMicroApp: null
      }
    },
    mounted () {
      console.log(this.$apps)
      // 通过URL访问指定子应用
      let currentPath = this.$route.path
      let currentAppFilterResult = this.$apps.filter(app => currentPath.startsWith(app.activeRule))
      if (Array.isArray(currentAppFilterResult) && currentAppFilterResult.length > 0) {
        loadMicroApp(currentAppFilterResult[0])
        return
      }
      // 访问主应用
      let activeApps = this.$apps.filter(app => app.active)
      console.log('activeApps', activeApps)
      activeApps.forEach(app => {
        loadMicroApp(app)
      })
    },
		methods: {
      goto(app) {
        console.log(app)
        if (this.currentMicroApp !== null) {
          this.currentMicroApp.mountPromise.then(() => this.currentMicroApp.unmount());
        }
        loadMicroApp(app)
        window.history.pushState({}, app.name, app.activeRule)
      }
		}
	}
</script>

<style>
  body,
  div {
    margin: 0px;
    padding: 0px;
  }
  html,
  body,
  #container {
    width: 100%;
    height: 100%;
  }
</style>

<style scoped lang="scss">
  .nav-con {
    .nav-item {
      line-height: 40px;
    }
  }
  a {
    color: #42b983;
    cursor: pointer;
  }
  .appContainer {
    margin-top: 50px;
  }
  .home,
  .el-container {
    width: 100%;
    height: 100%;
  }
  .side-bar-con {
    display: flex;
    flex-direction: column;
    .banner {
      background-color: rgb(65, 141, 233);
      color: white;
      height: 60px;
      font-weight: bold;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
  }
  .el-header, .el-footer {
    background-color: white;
    color: #333;
    text-align: right;
    line-height: 60px;
    box-shadow:0px 4px 5px 0px rgba(41,43,44,0.08);
  }

  .el-aside {
    background-color: white;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    background-color: rgb(246, 247, 251);
    color: #333;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style>
